import { LayoutStateModel } from "./models";

export const getLoaderStatus = (state: LayoutStateModel): boolean => {
  return state.loading;
};
